/* global VanillaCalendar, Block */
"use strict";

($dt => {

	const { Functions, Constants } = $dt.TopicGrid;

	// i8n texts
	const { topic_label_texts } = $dt;

	// Localized Constants
	const { anim_delay, TOPIC_TYPES } = Constants;

	// Localize functions
	const {
		dev_startup,
		on_nothing,
		convert_egalaxy_date,
		clean_egalaxy_time,
		format_money,
		repaint_elem,
		create_inner_screen,
		calculate_chaperones,
		apply_form_validation_to_summary,
		get_price_for_target,
		get_total_price_for_target_by_topic,
		make_date_string_into_datetime_string,
		maybe_include_addon_summary_line,
	} = Functions;

	// Screen Preparations are defined in the `topic-grid/outer-X-inner-Y.js` files.
	const inner_screen_preparations = $dt.TopicGrid.ScreenFunctions;

	// Storage for calendar availability for scenarios where re-checks aren't needed
	let last_retrieved_availability_dates = [];
	
	const controller = {

		/**
		 * @uses topic-grid/ajax-init-session.js
		 */
		InitSession: Functions.InitSession,

		/**
		 * @uses topic-grid/ajax-check-calendar-availability.js
		 */
		CheckCalendarAvailability: Functions.CheckCalendarAvailability,

		/**
		 * @uses topic-grid/ajax-get-date-times.js
		 */
		GetDateTimes: Functions.GetDateTimes,

		/**
		 * This function loads the screens into memory, preparing UX events along the way
		 * @param {Block} block 
		 */
		PrepareScreens: block => {
			const { overlay_content_elem, all_screens } = block;
			const [ outer_screen_elems ] = [
				overlay_content_elem.querySelectorAll('.overlay-screen')
			];

			outer_screen_elems.forEach(outer_elem => {
				const outer_screen = {
					outer_elem: outer_elem,
					index: parseInt(outer_elem.getAttribute('data-screen-index')),
					inner_screens: [],
					RecallInnerScreenButtons: () => {
						outer_screen.inner_screens.forEach(inner_screen => {
							inner_screen.RecallButtons();
						});
					},
					Show: () => {
						// This fires whenever the outer screen is targeted, even if it is already visible.
					}
				};

				// Prepare screen and inner contents
				switch (outer_screen.index) {
					case 0:
						// Main two column screen
						controller.PrepareOuterScreen0(block, outer_screen);
						break;
					case 1:
						// One column screen for anonymous info collect
						controller.PrepareOuterScreen1(block, outer_screen);
						break;
					case 2:
						// Two column deposit payment collect
						controller.PrepareOuterScreen2(block, outer_screen);
						break;
				}

				// Add screen to collection
				all_screens.push(outer_screen);
			});
		},

		PrepareOuterScreen0: (block, outer_screen) => {
			const { outer_elem } = outer_screen;
			const [ inner_screen_elems ] = [ 
				outer_elem.querySelectorAll('.screen-right')
			];

			const show_order_pane = () => {
				const [ summary_pane, price_pane ] = [
					outer_elem.querySelector('.topic-summary-pane'),
					outer_elem.querySelector('.price-info-pane')
				];
				if (summary_pane && price_pane) {
					const summary_html = controller.CreateHtmlSummary(block, true, true, false, true);
					summary_pane.classList.remove('pane-is-active');
					price_pane.classList.add('pane-is-active');

					const order_summary_elem = price_pane.querySelector('.order-summary');
					if (order_summary_elem) {
						order_summary_elem.innerHTML = summary_html;
					}
				}
			};

			const restore_overview_pane = () => {
				const [ summary_pane, price_pane ] = [
					outer_elem.querySelector('.topic-summary-pane'),
					outer_elem.querySelector('.price-info-pane')
				];
				if (summary_pane && price_pane) {
					summary_pane.classList.add('pane-is-active');
					price_pane.classList.remove('pane-is-active');

					const order_summary_elem = price_pane.querySelector('.order-summary');
					if (order_summary_elem) {
						order_summary_elem.innerHTML = '';
					}
				}
			};

			const toggle_left_pane = (show_order_details) => {
				if (show_order_details) {
					show_order_pane();
				} else {
					restore_overview_pane();
				}
			};

			inner_screen_elems.forEach(inner_elem => {
				const inner_screen = create_inner_screen(inner_elem, parseInt(inner_elem.getAttribute('data-screen-right-index')));
				inner_screen.button_wrapper = inner_elem.querySelector('.button-wrapper');

				// Prepare the screen
				if (inner_screen.index >= 0 && inner_screen.index <= 7) {
					inner_screen_preparations['o0_i' + inner_screen.index](block, inner_screen, controller, toggle_left_pane);
				}

				// Add to collection
				outer_screen.inner_screens.push(inner_screen);
			});

			// For Select Date Screen
			block.calendar_date_clicked_events.push(() => {
				show_order_pane();
			});

			// For Date Cleared
			block.calendar_date_selection_cleared_events.push(() => {
				restore_overview_pane();
			});
		},

		PrepareOuterScreen1: (block, outer_screen) => {
			const { outer_elem } = outer_screen;

			// Only one screen (no true inner screens, so we'll use the outer as a simulated inner for consistency with nested screens)
			const inner_screen = create_inner_screen(outer_elem, 0);

			// Prepare the screen
			inner_screen_preparations.o1_i0(block, inner_screen, controller);

			// Add to collection
			outer_screen.inner_screens.push(inner_screen);
		},

		PrepareOuterScreen2: (block, outer_screen) => {
			const { outer_elem } = outer_screen;
			const [
				inner_screen_elems,
				summary_elem,
				deposit_elem,
				summary_title,
				amount_label_elem,
				deposit_note_elems,
			] = [ 
				outer_elem.querySelectorAll('.screen-right'),
				outer_elem.querySelector('.deposit-summary .order-summary'),
				outer_elem.querySelector('.deposit-summary .total-deposit'),
				outer_elem.querySelector('.deposit-summary .topic-titles'),
				outer_elem.querySelector('.deposit-summary .deposit-amount-label'),
				outer_elem.querySelectorAll('.deposit-summary .deposit-amount-note'),
			];

			const on_pay_details_changed = (paytype_selected, amount_selected) => {
				// when the payment type changes or amount changes
				const { current_topic, scheduling_info } = block;
				const selected_date_obj = new Date(scheduling_info.selected_date + ' 00:00:00');
				deposit_note_elems.forEach((note_elem) => {
					note_elem.classList.add('hidden');
				});
				if (paytype_selected === 'cc') {
					switch (amount_selected) {
						case 'full':
							amount_label_elem.innerHTML = topic_label_texts.full_amount_due_label;
							deposit_elem.innerHTML =
								format_money(
									get_total_price_for_target_by_topic(current_topic, scheduling_info, selected_date_obj)
								);
							break;
						case 'deposit':
							amount_label_elem.innerHTML = topic_label_texts.deposit_amount_due_label;
							deposit_elem.innerHTML = format_money(current_topic.deposit_amount);
							deposit_note_elems.forEach((note_elem) => {
								note_elem.classList.remove('hidden');
							});
							break;
						default:
							// Not selected yet
							amount_label_elem.innerHTML = topic_label_texts.minimum_amount_due_label;
							deposit_elem.innerHTML = format_money(current_topic.deposit_amount);
							break;
					}
				} else if (paytype_selected === 'po') {
					amount_label_elem.innerHTML = topic_label_texts.po_amount_due_label;
					deposit_elem.innerHTML =
						format_money(
							get_total_price_for_target_by_topic(current_topic, scheduling_info, selected_date_obj)
						);
				} else {
					// Paytype reset
					amount_label_elem.innerHTML = topic_label_texts.minimum_amount_due_label;
					deposit_elem.innerHTML = format_money(current_topic.deposit_amount);
				}
			};

			// Setup outer screen
			outer_screen.Show = () => {
				const { current_topic } = block;

				// Populate left column
				summary_title.innerHTML = 
					`<p class="program-name">${current_topic.sales_program.name}</p>
					<p class="topic-name">${current_topic.title}</p>`;
				summary_elem.innerHTML = controller.CreateHtmlSummary(block, true, true, false);
			};

			// Setup inner screens
			inner_screen_elems.forEach(inner_elem => {
				const inner_screen = create_inner_screen(inner_elem, parseInt(inner_elem.getAttribute('data-screen-right-index')));
				inner_screen.button_wrapper = inner_elem.querySelector('.button-wrapper');

				// Prepare the screen
				if (inner_screen.index >= 0 && inner_screen.index <= 1) {
					inner_screen_preparations['o2_i' + inner_screen.index](block, inner_screen, controller, on_pay_details_changed);
				}

				// Add to collection
				outer_screen.inner_screens.push(inner_screen);
			});
		},

		/**
		 * This function is called on initial topic selection. It fills HTML elements with topic information.
		 * @param {Block} block 
		 */
		LoadTopicElements: block => {
			const { overlay_content_elem, current_topic } = block;
			const [ img_elems, title_elems, program_elems, desc_elems, has_notification_elems ] = [
				overlay_content_elem.querySelectorAll('.topic-image'),
				overlay_content_elem.querySelectorAll('.topic-name'),
				overlay_content_elem.querySelectorAll('.program-name'),
				overlay_content_elem.querySelectorAll('.topic-desc'),
				overlay_content_elem.querySelectorAll('.maybe-has-notification'),
				//overlay_content_elem.querySelectorAll('.topic-price')
			];
			
			img_elems.forEach(elem => {
				elem.innerHTML = current_topic ? current_topic.image_html : '';
			});
			title_elems.forEach(elem => {
				elem.innerHTML = current_topic ? current_topic.title : '';
			});
			program_elems.forEach(elem => {
				elem.innerHTML = current_topic ? current_topic.sales_program.name : '';
			});
			desc_elems.forEach(elem => {
				if (current_topic) {
					elem.innerHTML = current_topic.description_html || '';
					if (current_topic.grades.length > 0) {
						let grades_html = '<p class="grades">Grades:';
						current_topic.grades.forEach(g => {
							grades_html += '<br>' + g;
						});
						grades_html += '</p>';
						elem.innerHTML += grades_html;
					}
				} else {
					elem.innerHTML = '';
				}
			});
			has_notification_elems.forEach(elem => {
				if (current_topic.has_notification) {
					elem.classList.add('has-notification');
				} else {
					elem.classList.remove('has-notification');
				}
			});

			if (current_topic.price >= 0) {
				// This feature becomes unsafe when there are price schedules in play since they have not yet selected a date.
				/*price_elems.forEach(elem => {
					elem.innerText = `Price: ${get_formatted_price_for_target(current_topic.price, current_topic.price_schedule, new Date())}`;
				});*/
			}
		},

		/**
		 * This function can be called any time a change in screens occurs. It will use the current selected screen to figure out what to display
		 * @param {Block} block 
		 */
		SetScreenUI: block => {
			const { current_screen, all_screens } = block;

			all_screens.forEach(outer_screen => {
				const { outer_elem, inner_screens } = outer_screen;

				if (outer_screen.index > current_screen.outer) {
					outer_elem.style.removeProperty('display');
					outer_elem.classList.add('passed');
					outer_screen.RecallInnerScreenButtons();
					setTimeout(() => {
						outer_elem.style.display = 'none';
					}, anim_delay);
				} else if (outer_screen.index === current_screen.outer) {
					outer_elem.style.removeProperty('display');

					// Short delay needed after removing the display none property
					setTimeout(() => {
						outer_elem.classList.remove('passed');
						outer_elem.classList.add('active');
					}, anim_delay);

					// Outer screen show (happens even if already in view)
					outer_screen.Show(block);

					// Screen is in view, check inner
					inner_screens.forEach(inner_screen => {
						controller.SetInnerScreenUI(block, inner_screen);
					});
				} else {
					outer_elem.style.removeProperty('display');
					outer_elem.classList.remove('passed');
					outer_elem.classList.remove('active');
					outer_screen.RecallInnerScreenButtons();
					setTimeout(() => {
						outer_elem.style.display = 'none';
					}, anim_delay);
				}
			});
		},

		/**
		 * Sets up the UX for an inner screen (screens that appear to the right side of an image/topic name). Only called when there is an update/change to screens.
		 * @param {Block} block 
		 * @param {InnerScreen} inner_screen
		 */
		SetInnerScreenUI: (block, inner_screen) => {
			const { current_screen } = block;
			const { inner_elem } = inner_screen;

			// Always clear inner screem form errors (if found)
			controller.ResetFormElementsWithinContainer(inner_elem);

			if (current_screen.inner > inner_screen.index) {
				// The inner screen has been moved passed
				inner_elem.style.removeProperty('display');
				inner_elem.classList.add('passed');
				inner_screen.RecallButtons();
				setTimeout(() => {
					inner_elem.style.display = 'none';
				}, anim_delay);
			} else if (current_screen.inner === inner_screen.index) {
				// The inner screen is in view
				inner_elem.style.removeProperty('display');

				// Move buttons to display
				if (inner_screen.button_wrapper) {
					block.overlay_screen_buttons_elem.appendChild(inner_screen.button_wrapper);
				}

				// Short delay needed after removing the display none property
				setTimeout(() => {
					inner_elem.classList.remove('passed');
					inner_elem.classList.add('active');
					repaint_elem(block.overlay_screen_right_port_elem);
				}, anim_delay);

				// In view
				inner_screen.Show();
			} else {
				// The inner screen is not yet in view
				inner_elem.style.removeProperty('display');
				inner_elem.classList.remove('passed');
				inner_elem.classList.remove('active');
				inner_screen.RecallButtons();
				setTimeout(() => {
					inner_elem.style.display = 'none';
				}, anim_delay);
			}
		},

		/**
		 * Opens the overlay and starts a new block. Optionally supply a desired screen to skip to a certain area (debug only)
		 * @param {Block} block 
		 * @param {*} topic
		 * @param {*} screen
		 */
		OpenTopicDetails: (block, topic, screen) => {
			// Is this a forced load (usually from dev testing)
			const is_forced_load = screen ? true : false;

			// Load the topic, open overlay
			block.current_topic = topic;

			// Reset a previously selected date
			if (!is_forced_load) {
				controller.ClearSelectedDate(block);
			}

			// Fill persistent topic elements
			controller.LoadTopicElements(block);

			screen = screen || {
				outer: 0,
				inner: block.contact_info.anon ? 1 : 0
			};

			// Reset screen status
			block.current_screen = screen;

			// Reset user selection
			if (!is_forced_load) {
				controller.ResetUserSelections(block);
			}

			// Set Screen UI
			controller.SetScreenUI(block);

			// (Dev testing force load calendar)
			if (is_forced_load) {
				// Only load calendar if this is a forced load
				controller.UpdateCalendar(block, true);
			}

			// Open Overlay
			$dt.Overlay.Open(overlay => {
				const overlay_content_elem = overlay.querySelector('.overlay-content');
				overlay_content_elem.innerHTML = '';
				overlay_content_elem.appendChild(block.overlay_content_elem);
			});
		},

		/**
		 * Designed to softly reset parts of user selections that are specific to a particular topic
		 * @param {Block} block 
		 */
		ResetUserSelections: block => {
			const { scheduling_info, d3df_page_options } = block;
			scheduling_info.class_info_questions = [];
			scheduling_info.available_times = [];
			scheduling_info.selected_event_id = false;
			scheduling_info.selected_date = false;
			scheduling_info.selected_time = false;
			scheduling_info.amount_to_pay = null;
			scheduling_info.order_id = false;
			d3df_page_options.submissionID = false;
			d3df_page_options.pageIndex = 0;
		},

		/**
		 * Closes the overlay and cleans up / resets screen data
		 * @param {Block} block 
		 */
		CloseTopicDetails: block => {
			//const { container } = block;

			// Close Overlay
			$dt.Overlay.Close();

			// Reset topic selection
			block.current_topic = false;
			controller.LoadTopicElements(block);

			// Reset user selection
			controller.ResetUserSelections(block);

			// Reset calendar
			block.calendar_elem.innerHTML = '';
			block.calendar = false;

			// Reset screen status
			block.current_screen = {
				outer: 0,
				inner: 0
			};
		},

		/**
		 * Used to locate topic details stored in the d3_wp_theme_js variable.
		 * @param {int} topic_id 
		 */
		FindTopic: topic_id => {
			let topic = false;
			if ($dt.topics) {
				topic = $dt.topics.find(t => { return t.id === topic_id; });
			}
			return topic;
		},

		/**
		 * Updates the users currently selected date and transitions to select time screen
		 * @param {Block} block 
		 */
		SelectDate: (block, selected_date) => {
			const { scheduling_info } = block;
			scheduling_info.selected_date = selected_date;

			controller.TriggerDateClickedEvents(block, selected_date);
		},

		/**
		 * Triggers all registered calendar_date_clicked_events
		 * @param {Block} block 
		 * @param {Date} selected_date 
		 */
		TriggerDateClickedEvents: (block, selected_date) => {
			block.calendar_date_clicked_events.forEach(on_date_clicked => {
				on_date_clicked(selected_date);
			});
		},

		/**
		 * Trigger a clearing of the scheduled date previously selected on the calendar.
		 * @param {Block} block 
		 */
		ClearSelectedDate: (block) => {
			const { scheduling_info } = block;
			scheduling_info.selected_date = false;

			block.calendar_date_selection_cleared_events.forEach(on_date_cleared => {
				on_date_cleared();
			});
		},

		/**
		 * Queries the server for event date availability based on num attendees and updates the calendar UX
		 * @param {Block} block 
		 */
		UpdateCalendar: (block, load_quiet, skip_availability_check) => {
			const { calendar_elem, calendar_settings, scheduling_info, current_topic } = block;
			//calendar_elem.innerHTML = `<p>${$dt.loading_text}</p>`;
			if (scheduling_info.reservation_attendees && scheduling_info.reservation_attendees > 0 && scheduling_info.reservation_attendees < 1000) {
				if (!load_quiet) {
					controller.StartWaiting(block);
				}
				const render_calendar = (block, dates) => {
					const cal_options = {...calendar_settings.cal_options};

					// Set enabled dates
					const cal_settings = cal_options.settings;
					cal_settings.range.enabled = [];
					dates.forEach(d => {
						cal_settings.range.enabled.push(d);
					});
					
					// Add our calendar click events
					cal_options.actions = {
						clickDay: (e, cal) => {
							if (cal.selectedDates.length > 0) {
								controller.SelectDate(block, cal.selectedDates[0]);
							}
						},
						getDays: (day, date, elem, buttonElem, cal) => {
							// New version of vanilla calendar that allows manipulating the day content
							const thisDate = new Date(date + ' 00:00:00');
							if (thisDate.getMonth() === cal.selectedMonth) {
								if (cal.rangeEnabled.includes(date)) {
									buttonElem.innerHTML =
										`<span class="day-num">${day}</span><span class="day-total">${
											current_topic.pricing_is_deferred ? '' :
											format_money(
												Math.ceil(get_total_price_for_target_by_topic(current_topic, scheduling_info, thisDate)),
												true,
											)
										}</span>`;
								} else {
									buttonElem.innerHTML =
										`<span class="day-num">${day}</span><span class="day-total"></span>`;
								}
							}
						}
					};

					// Calendar UX, Make sure Calendar JS library is ready
					// NOTE: If you're reviewing this code wondering why we reload the calendar with each topic click or attendees update, it's because at the time of development the
					//   calendar library did not have a means for updating things like which dates are enabled.
					calendar_elem.innerHTML = '';
					// An inner element is needed so that a new DOM element can be created. The calendar library will keep adding events if an existing dom element is used
					const inner_calendar_elem = document.createElement('div');
					calendar_elem.appendChild(inner_calendar_elem);

					if (dates.length === 0) {
						// No dates available for current number of attendees and topic selection
						calendar_elem.innerHTML = `<p>${$dt.no_dates_text}</p>`;
					} else {
						// Attempts to set the month view based on the earliest date in the response collection of dates.
						try {
							let earliestDate = new Date(make_date_string_into_datetime_string(dates[0]));
							dates.forEach(currentDateString => {
								const testDate = new Date(make_date_string_into_datetime_string(currentDateString));
								if (testDate < earliestDate) {
									earliestDate = testDate;
								}
							});
							cal_options.date.today = earliestDate;
						} catch (dateEx) {
							cal_options.date.today = calendar_settings.block_settings.first_date;
						}

						const onCalendarJsReady = () => {
							let preselect_dates = false;
							// https://vanilla-calendar.pro/docs/reference/additionally/settings#selected-dates
							if (block.calendar) {
								if (!cal_settings.selected) {
									cal_settings.selected = {};
								}

								// Reselect the last month/year the user was looking at
								if (block.calendar.selectedMonth && block.calendar.selectedYear) {
									cal_settings.selected.month = block.calendar.selectedMonth;
									cal_settings.selected.year = block.calendar.selectedYear;
								}

								// Reselect the last date clicked (if any)
								if (block.calendar.selectedDates && block.calendar.selectedDates.length > 0) {
									preselect_dates = true;
									cal_settings.selected.dates = block.calendar.selectedDates;
								} else {
									cal_settings.selected.dates = [];
								}
							}
							block.calendar = new VanillaCalendar(inner_calendar_elem, cal_options);
							block.calendar.init();

							if (preselect_dates) {
								scheduling_info.selected_date = cal_settings.selected.dates[0];
								controller.TriggerDateClickedEvents(block, cal_settings.selected.dates[0]);
							}
						};

						$dt.OnLibraryAvailable([ 'VanillaCalendar' ], onCalendarJsReady, 0.25);
					}

					// End waiting
					if (!load_quiet) {
						controller.EndWaiting(block);
					}
				};
				if (skip_availability_check && last_retrieved_availability_dates.length > 0) {
					render_calendar(block, last_retrieved_availability_dates);
				} else {
					controller.CheckCalendarAvailability(block, resp => {
						last_retrieved_availability_dates = resp.dates;
						render_calendar(block, resp.dates);
					});
				}
			}
		},

		/**
		 * Prepares calendar settings at load time once the server date is retrieved
		 * @param {Block} block 
		 */
		PrepareCalendarSettings: block => {
			// Calendar Opts
			const [ shortDateString, today, first_date, last_date ] =  [
				date => { return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`; },
				// $dt.todays_date is set in the theme controller, setting this server side will help reduce potential funny business with date queries back to the server
				// Potential issue here is that if the markup gets cached, it could set it to an older date
				new Date(block.todays_date),
				new Date(block.todays_date),
				new Date(block.todays_date)
			];

			// Push out "today" to one day ahead, this solves an end of month issue where an unselectable month appears on load
			today.setDate(today.getDate() + 1);
	
			// First date in calendar that a user can select
			first_date.setDate(first_date.getDate() + 1);
	
			// Last date in calendar that a user can select
			last_date.setFullYear(today.getFullYear() + 1);
			last_date.setDate(0);
	
			block.calendar_settings = {
				block_settings: {
					first_date: first_date,
					last_date: last_date
				},
				cal_options: {
					date: {
						today: first_date,
						min: shortDateString(first_date),
						max: shortDateString(last_date),
					},
					// Calendar Settings - https://vanilla-calendar.pro/docs/reference/additionally/settings
					settings: {
						visibility: {
							disabled: false,
							weekend: false,
							today: false,
							daysOutside: false,
							theme: 'light' // new version of vanilla calendar force theme (defaults to OS preferred)
						},
						range: {
							disableAllDays: true,
							enabled: []
						}
					}
				}
			};
		},

		ResetFormValidation: form => {
			controller.ResetFormElementsWithinContainer(form.currentContainer, form.errorMessageType);
		},

		ResetFormElementsWithinContainer: (container, errorMessageType) => {
			const invalid_elems = container.querySelectorAll('.d3df_invalid');
			invalid_elems.forEach(invalid => {
				invalid.classList.remove('d3df_invalid');
			});
			if (!errorMessageType || errorMessageType === 'inline') {
				const inline = container.querySelectorAll('.d3df_error_message');
				for (let inlineCount = 0; inlineCount < inline.length; inlineCount++) {
					inline[inlineCount].textContent = '';
				}
			}
			const empty = container.querySelector('.d3df_simple_error_summary');
			while (empty && empty.firstChild) {
				empty.removeChild(empty.firstChild);
			}
		},

		/**
		 * Executes simple validation messages against a form container.
		 * @param {*} form
		 * @param {Array} errors 
		 */
		FormValidationFailed: (form, errors) => {
			apply_form_validation_to_summary(form.currentContainer, form, errors);
		},

		/**
		 * Adds the known scheduling info for topic and event date/time to a data object for form submissions
		 * @param {Block} block 
		 * @param {*} data
		 */
		SetSchedulingFormData: (block, data) => {
			const { scheduling_info } = block;
			data.topic_id = block.current_topic.id;
			data.event_id = scheduling_info.selected_event_id;
			data.selected_date = scheduling_info.selected_date;
			data.selected_time = scheduling_info.selected_time;
			data.num_attendees = scheduling_info.reservation_attendees;
			data.children_attendees = scheduling_info.children_attendees;
			data.paid_adult_attendees = scheduling_info.paid_adult_attendees;
			data.addon_attendees = scheduling_info.addon_attendees;

			if (!data.class_grade) {
				data.class_grade = scheduling_info.class_grade;
			}

			if (!data.notes) {
				data.notes = scheduling_info.notes;
			}

			scheduling_info.class_info_questions.forEach(question => {
				if (!data['question_' + question.index]) {
					data['question_' + question.index] = question.answer;
				}
			});

			if (!data.paytype_selected) {
				data.paytype_selected = scheduling_info.paytype_selected;
			}
			if (!data.amount_to_pay) {
				data.amount_to_pay = scheduling_info.amount_to_pay;
			}
		},

		/**
		 * Adds contact info to the data block (mainly for anonymous)
		 * @param {Block} block 
		 * @param {*} data
		 */
		SetContactInfoFormData: (block, data) => {
			const { contact_info } = block;
			if (contact_info.anon) {
				data.firstname = contact_info.firstname;
				data.lastname = contact_info.lastname;
				data.email = contact_info.email;
				data.phone = contact_info.phone;
				data.school = contact_info.school;

				// New address info
				data.street_address1 = contact_info.street_address1;
				data.city = contact_info.city;
				data.state = contact_info.state;
				data.zip = contact_info.zip;
			}
		},

		/**
		 * Create summary output in HTML format based on the collected info/topic
		 * @param {Block} block 
		 * @param {boolean} include_reservation_price
		 * @returns {string}
		 */
		CreateHtmlSummary: (block, include_reservation_price, exclude_notes, show_deposit, hide_time) => {
			const { scheduling_info, contact_info, current_topic } = block;
			const { children, paid_adults, addon, pricing_is_deferred } = current_topic;

			const school_html = contact_info.school_name.length > 0 ? `<p class="school-title">${contact_info.school_name}</p>` : '';

			let reserved_html = '', costs, children_price = 0, paid_adults_price = 0, addon_price = 0;
			const selected_date_obj = new Date(scheduling_info.selected_date + ' 00:00:00');
			const reservation_price = get_price_for_target(current_topic.price, current_topic.price_schedule, selected_date_obj);

			if (children && children.children_price) {
				children_price = get_price_for_target(children.children_price, children.price_schedule, selected_date_obj);
			}

			if (paid_adults && paid_adults.paid_adults_price) {
				paid_adults_price = get_price_for_target(paid_adults.paid_adults_price, paid_adults.price_schedule, selected_date_obj);
			}

			if (addon && addon.price) {
				addon_price = get_price_for_target(addon.price, addon.price_schedule, selected_date_obj);
			}

			const output_money = (amount, exclude_parens) => {
				if (pricing_is_deferred)
					return '';

				const amount_formatted = format_money(amount);
				if (exclude_parens)
					return amount_formatted;

				return `(${amount_formatted})`;
			};

			switch (current_topic.topic_type) {
				case TOPIC_TYPES.ONSITE:
					
					costs = 
						reservation_price * scheduling_info.reservation_attendees +
						children_price * scheduling_info.children_attendees +
						paid_adults_price * scheduling_info.paid_adult_attendees +
						addon_price * scheduling_info.addon_attendees;

					if (include_reservation_price && reservation_price > 0) {
						reserved_html = 
							`<tr><td>Reservation</td><td>${output_money(reservation_price * scheduling_info.reservation_attendees, true)}</td></tr>`;
					}

					reserved_html += 
						`<tr><td>Children</td><td>${scheduling_info.children_attendees} ${output_money(children_price * scheduling_info.children_attendees)}</td></tr>
						 <tr><td>Free Adults</td><td>${calculate_chaperones(scheduling_info.children_attendees, current_topic)} ${output_money(0)}</td></tr>
						 <tr><td>Paid Adults</td><td>${scheduling_info.paid_adult_attendees} ${output_money(paid_adults_price * scheduling_info.paid_adult_attendees)}</td></tr>`;

					reserved_html += maybe_include_addon_summary_line(current_topic, scheduling_info, addon_price, output_money);

					if (!pricing_is_deferred) {
						reserved_html += 
							 `<tr><td><strong>Total</strong></td><td><strong>${format_money(costs)}</strong></td></tr>`;
					}
					break;
				case TOPIC_TYPES.ONSITE_SELF_GUIDED:
					costs = 
						reservation_price * scheduling_info.reservation_attendees +
						children_price * scheduling_info.children_attendees +
						paid_adults_price * scheduling_info.paid_adult_attendees +
						addon_price * scheduling_info.addon_attendees;

					if (include_reservation_price && reservation_price > 0) {
						reserved_html = 
							`<tr><td>Reservation</td><td>${output_money(reservation_price * scheduling_info.reservation_attendees, true)}</td></tr>`;
					}

					reserved_html += 
						`<tr><td>Children</td><td>${scheduling_info.children_attendees} ${output_money(children_price * scheduling_info.children_attendees)}</td></tr>
						<tr><td>Paid Adults</td><td>${scheduling_info.paid_adult_attendees} ${output_money(paid_adults_price * scheduling_info.paid_adult_attendees)}</td></tr>`;

					reserved_html += maybe_include_addon_summary_line(current_topic, scheduling_info, addon_price, output_money);

					if (!pricing_is_deferred) {
						reserved_html += 
							 `<tr><td><strong>Total</strong></td><td><strong>${format_money(costs)}</strong></td></tr>`;
					}
					break;
				case TOPIC_TYPES.SCIENCE_TO_GO:
					costs = 
						reservation_price * scheduling_info.reservation_attendees +
						children_price * scheduling_info.children_attendees +
						addon_price * scheduling_info.addon_attendees;

					if (include_reservation_price && reservation_price > 0) {
						reserved_html = 
							`<tr><td>Reservation</td><td>${output_money(reservation_price * scheduling_info.reservation_attendees, true)}</td></tr>`; 
					}
					
					reserved_html += 
						`<tr><td>Children</td><td>${scheduling_info.children_attendees} ${output_money(children_price * scheduling_info.children_attendees)}</td></tr>`;

					reserved_html += maybe_include_addon_summary_line(current_topic, scheduling_info, addon_price, output_money);

					if (!pricing_is_deferred) {
						reserved_html += 
							 `<tr><td><strong>Total</strong></td><td><strong>${format_money(costs)}</strong></td></tr>`;
					}
					break;
				case TOPIC_TYPES.COMMUNITY:
					costs =
						addon_price * scheduling_info.addon_attendees;
					
					reserved_html = 
						`<tr><td>Reserved:</td><td>${scheduling_info.reservation_attendees}</td></tr>`;

					reserved_html += maybe_include_addon_summary_line(current_topic, scheduling_info, addon_price, output_money);

					if (!pricing_is_deferred) {
						reserved_html += 
							 `<tr><td><strong>Total</strong></td><td><strong>${format_money(reservation_price * scheduling_info.reservation_attendees)}</strong></td></tr>`;
					}
					break;
			}

			if (
				show_deposit &&
				current_topic.deposit_amount !== null &&
				scheduling_info.paytype_selected !== 'po' &&
				scheduling_info.amount_to_pay === 'deposit' && 
				!pricing_is_deferred
			) {
				reserved_html +=
					`<tr><td>Deposit</td><td>${format_money(current_topic.deposit_amount)}</td></tr>`;
			}

			let tabular_html = 
				`<table cellspacing="0"><tr><td>Date</td><td>${convert_egalaxy_date(scheduling_info.selected_date)}</td></tr>`;

			if (!hide_time) {
				tabular_html +=
					`<tr><td>Time</td><td>${clean_egalaxy_time(scheduling_info.selected_time)}</td></tr>`;
			}
			
			tabular_html += reserved_html;

			if (!exclude_notes) {
				tabular_html +=
					`<tr><td colspan="2">Notes:<br><span>${scheduling_info.notes}</span></td></tr>`;
			}

			tabular_html += '</table>';

			return school_html + tabular_html;
		},
		
		/**
		 * Transition the overlay into a wait state for server side processes
		 * @param {Block} block 
		 */
		StartWaiting: block => {
			block.overlay_content_elem.querySelector('.topic-overlay-wait-screen').classList.add('active');
		},

		/**
		 * Terminate a wait state upon server side process completion
		 * @param {Block} block 
		 */
		EndWaiting: block => {
			block.overlay_content_elem.querySelector('.topic-overlay-wait-screen').classList.remove('active');
		}
	};

	$dt.blocks['topic-grid'] = {
		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		 LoadBlock: container => {

			const block = new Block(container, on_nothing);

			// Localize block properties
			const { grid_elem, topic_card_links } = block;

			// Setup grid and filters
			$dt.Grid.CreateGrid(grid_elem);

			// Init Session
			controller.InitSession(block, () => {
				// Prepare calendar settings
				controller.PrepareCalendarSettings(block);

				// Prepare Screens
				controller.PrepareScreens(block);

				// Setup topic clicks
				topic_card_links.forEach(elem => {
					const topic_id = parseInt(elem.getAttribute('data-topic-id'));
					const topic = controller.FindTopic(topic_id);

					if (topic) {
						elem.addEventListener('click', () => {
							controller.OpenTopicDetails(block, topic);
						});
					}
				});

				// Dev - Load and Skip Screen
				dev_startup(controller, block);
			});

			// Setup Close Button Clicks if a custom close button is added
			const close_btn_elem = container.querySelector('.topic-overlay-close-button');
			close_btn_elem.addEventListener('click', () => {
				controller.CloseTopicDetails(block);
			});
		}
	};
	
})(window.d3_wp_themejs);
